import { render, staticRenderFns } from "./Requesters.vue?vue&type=template&id=333ffdcf&scoped=true"
import script from "./Requesters.vue?vue&type=script&lang=js"
export * from "./Requesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333ffdcf",
  null
  
)

export default component.exports